/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute, FormState, FormStateBuilder } from '@gh/common-shared';
import { DialogInput, FormMode } from '@gh/core-ui';
import { ReportRohcArea } from '../../../resources/report-roch-details.model';

export type ReportRohcAreaDialogConfig = {
  isCreateMode: boolean;
  area: ReportRohcArea;
};

@Component({
  standalone: false,
  selector: 'gh-report-rohc-area-dialog',
  templateUrl: 'report-rohc-area-dialog.component.html',
  styleUrls: ['report-rohc-area-dialog.component.scss'],
})
export class ReportRohcAreaDialogComponent implements OnInit, DialogInput<ReportRohcAreaDialogConfig> {
  input: ReportRohcAreaDialogConfig;

  form: FormState<ReportRohcArea>;

  get title(): string {
    return this.form.createMode ? 'lbl_create_area' : 'lbl_edit_area';
  }

  constructor(private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder) {
  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value: this.input.area,
      mode: this.input.isCreateMode ? FormMode.CreateMode : FormMode.EditMode,
      children: {
        id: void 0,
        name: { required: true },
        description: void 0,
        dirtyType: void 0,
        version: void 0,
      },
    });
  }

  onSave(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.submitValue);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

export const reportRohcAreaDialogRoute = createDialogRoute({
  component: ReportRohcAreaDialogComponent,
});
